import script from "./ShakyoInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoInformation.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoInformation.vue?vue&type=style&index=0&id=6ae22217&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae22217"]])

export default __exports__